import React from 'react';
import loadable from '../../utils/loadable';
import './index.less';
// const Portfolio = loadable(()=>import('../../components/portfolio'));
const WorkWithUs = loadable(() => import('../../components/workWithUs'));
const Culture = loadable(() => import('../../components/culture'));
// import WorkWithUs from '../../components/workWithUs';
// import Culture from '../../components/culture';
// import TeamAvatars from '../../components/teamAvatars';

class AboutPage extends React.Component {

    render() {
        return (
            <div className='page-container'>
                {/* <TeamAvatars /> */}

                {/* <Portfolio /> */}

                <Culture />

                <WorkWithUs />

            </div>
        );
    }
}

export default AboutPage;
